import { RS } from '../../../types';

export const ackCommentSelector = (state: RS) => state.details.ack.value.comment;
export const ackSelector = (state: RS) => state.details.ack.value;
export const ackedSelector = (state: RS) => state.details.ack.value.value;
export const ackStatusSelector = (state: RS) => state.details.ack.status;
